import { render, staticRenderFns } from "./PrevNext.vue?vue&type=template&id=d2b70198&"
import script from "./PrevNext.vue?vue&type=script&lang=js&"
export * from "./PrevNext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports